export default [
    {
        name: 'cadastro-bairro',
        path: 'bairro',
        redirect: 'bairro/index',
        component: () => import(/* webpackChunkName: 'cadastro-bairro' */ '@/views/cadastro/bairro/Index'),
        children: [
            {
                meta: {title: 'Lista de bairros'},
                name: 'cadastro-bairro-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'cadastro-bairro' */ '@/views/cadastro/bairro/List.vue'),
            },
        ],
    },
]